export default __webpack_public_path__ + "static/media/banner1.a645ad88.png";